<template>
  <div id="mitsumori-wrapper">
    <h2 class="title">年間報酬簡易計算フォーム</h2>

    <div class="half-style left">
      <h3>１．月次顧問報酬</h3>
    </div>

    <div class="half-style left">
      <div class="label-style">組織区分</div>
      <div>
        <md-radio name="soshikiKbn" v-model="soshikiKbn" md-value="法人" class="md-primary">法人</md-radio>
        <md-radio name="soshikiKbn" v-model="soshikiKbn" md-value="個人" class="md-primary">個人</md-radio>
      </div>
    </div>

    <md-input-container class="half-style">
      <label for="gyosyuKbn">業種区分</label>
      <md-select name="gyosyuKbn" id="gyosyuKbn" v-model="gyosyuKbn">
        <md-option value="卸売業">卸売業</md-option>
        <md-option value="人材派遣業">人材派遣業</md-option>
        <md-option value="小売業">小売業</md-option>
        <md-option value="製造業">製造業</md-option>
        <md-option value="飲食業">飲食業</md-option>
        <md-option value="サービス業">サービス業</md-option>
        <md-option value="建設業">建設業</md-option>
        <md-option value="医業">医業</md-option>
        <md-option value="造園業">造園業</md-option>
        <md-option value="運送業">運送業</md-option>
        <md-option value="保険業">保険業</md-option>
        <md-option value="不動産業">不動産業</md-option>
        <md-option value="その他">その他</md-option>
      </md-select>
    </md-input-container>

    <div class="half-style left">
      <div class="label-style">消費税区分</div>
      <div>
        <md-radio name="syohizeiKbn" v-model="syohizeiKbn" md-value="免税事業者" class="md-primary">免税事業者</md-radio>
        <md-radio name="syohizeiKbn" v-model="syohizeiKbn" md-value="本則課税" class="md-primary">本則課税</md-radio>
        <md-radio name="syohizeiKbn" v-model="syohizeiKbn" md-value="簡易課税" class="md-primary">簡易課税(売上5000万円以下)
        </md-radio>
      </div>
    </div>

    <div class="half-style left">
      <div class="label-style">訪問回数</div>
      <div>
        <md-radio name="homonKaisu" v-model="homonKaisu" md-value="月次" class="md-primary">月次</md-radio>
        <md-radio name="homonKaisu" v-model="homonKaisu" md-value="年一" class="md-primary">年一</md-radio>
      </div>
    </div>

    <md-input-container class="half-style">
      <label>前年売上高</label>
      <md-input v-model="zenUri" class="right" @input.native="validateNumber($event)"
                @focus="manageComma('zenUri', true)" @blur="manageComma('zenUri', false)"/>
      <span class="unit">円</span>
    </md-input-container>
    <md-input-container class="half-style">
      <label>前々年売上高</label>
      <md-input v-model="zenZenUri" class="right" @input.native="validateNumber($event)"
                @focus="manageComma('zenZenUri', true)" @blur="manageComma('zenZenUri', false)"/>
      <span class="unit">円</span>
    </md-input-container>
    <md-input-container class="half-style">
      <label>{{soshikiKbn === '法人' ? '前年役員報酬' : '前年事業所得'}}</label>
      <md-input v-model="zenHosyu" class="right" @input.native="validateNumber($event)"
                @focus="manageComma('zenHosyu', true)" @blur="manageComma('zenHosyu', false)"/>
      <span class="unit">円</span>
    </md-input-container>
    <md-input-container class="half-style">
      <label>{{soshikiKbn === '法人' ? '前々年役員報酬' : '前々年事業所得'}}</label>
      <md-input v-model="zenZenHosyu" class="right" @input.native="validateNumber($event)"
                @focus="manageComma('zenZenHosyu', true)" @blur="manageComma('zenZenHosyu', false)"/>
      <span class="unit">円</span>
    </md-input-container>

    <div class="half-style left">
      <h3>２．会計ソフト導入 or 記帳代行</h3>
    </div>

    <div class="half-style left">
      <div class="label-style">会計ソフト</div>
      <div>
        <md-radio name="kaikeiSoftKbn" v-model="kaikeiSoftKbn" md-value="記帳代行" class="md-primary">記帳代行</md-radio>
        <md-radio name="kaikeiSoftKbn" v-model="kaikeiSoftKbn" md-value="指定ソフト導入" class="md-primary">指定ソフト導入</md-radio>
        <md-radio name="kaikeiSoftKbn" v-model="kaikeiSoftKbn" md-value="部門別管理" class="md-primary">部門別管理</md-radio>
      </div>
    </div>

    <md-input-container class="half-style">
      <label>仕訳数</label>
      <md-input v-model="shiwakeSu" class="right" @input.native="validateNumber($event)"
                @focus="manageComma('shiwakeSu', true)" @blur="manageComma('shiwakeSu', false)"/>
      <span class="unit">仕訳／月間</span>
    </md-input-container>

    <div class="half-style left">
      <div class="label-style">帳簿</div>
      <div>
        <md-radio name="tyoboKbn" v-model="tyoboKbn" md-value="" class="md-primary">無し</md-radio>
        <md-radio name="tyoboKbn" v-model="tyoboKbn" md-value="帳簿書類整理済" class="md-primary">帳簿書類整理済</md-radio>
        <md-radio name="tyoboKbn" v-model="tyoboKbn" md-value="現金出納帳のみ" class="md-primary">現金出納帳のみ</md-radio>
        <md-radio name="tyoboKbn" v-model="tyoboKbn" md-value="完全丸投" class="md-primary">完全丸投</md-radio>
      </div>
    </div>

    <div class="half-style left">
      <h3>３．給与計算 and 年末調整</h3>
    </div>

    <div class="half-style left">
      <div class="label-style">給与計算代行</div>
      <div>
        <md-radio name="kyuyoKeisanDaiko" v-model="kyuyoKeisanDaiko" md-value="無" class="md-primary">無</md-radio>
        <md-radio name="kyuyoKeisanDaiko" v-model="kyuyoKeisanDaiko" md-value="有" class="md-primary">有</md-radio>
      </div>
    </div>

    <md-input-container class="half-style">
      <label>従業員数</label>
      <md-input v-model="zyugyoinSu" class="right" @input.native="validateNumber($event)"
                @focus="manageComma('zyugyoinSu', true)" @blur="manageComma('zyugyoinSu', false)"/>
      <span class="unit">人</span>
    </md-input-container>

    <div class="half-style left">
      <h4>年末調整関係</h4>
    </div>

    <md-input-container class="half-style sub-content">
      <label>市町村</label>
      <md-input v-model="shityosonSu" class="right" @input.native="validateNumber($event)"/>
      <span class="unit">件</span>
    </md-input-container>

    <md-input-container class="half-style sub-content">
      <label>税務署</label>
      <md-input v-model="zeimusyoSu" class="right" @input.native="validateNumber($event)"/>
      <span class="unit">件</span>
    </md-input-container>

    <md-input-container class="half-style sub-content">
      <label>不動産</label>
      <md-input v-model="fudosanSu" class="right" @input.native="validateNumber($event)"/>
      <span class="unit">件</span>
    </md-input-container>

    <md-input-container class="half-style sub-content">
      <label>報酬</label>
      <md-input v-model="hosyuSu" class="right" @input.native="validateNumber($event)"/>
      <span class="unit">件</span>
    </md-input-container>

    <md-input-container class="half-style sub-content">
      <label>その他</label>
      <md-input v-model="sonotaSu" class="right" @input.native="validateNumber($event)"/>
      <span class="unit">件</span>
    </md-input-container>

    <!--<md-input-container class="half-style">
		  <label>合計 (自動入力)</label>
		  <md-input v-model="nenmatsuGokei" class="right" @input.native="validateNumber($event)" disabled/>
		</md-input-container>-->

    <div class="half-style left">
      <h3>４．償却資産税申告書作成・提出</h3>
    </div>

    <md-input-container class="half-style">
      <label>提出市町村</label>
      <md-input v-model="teisyutsuShityoson" class="right" @input.native="validateNumber($event)"/>
      <span class="unit">部</span>
    </md-input-container>

    <md-input-container class="half-style">
      <label>移動資産</label>
      <md-input v-model="idoShisan" class="right" @input.native="validateNumber($event)"/>
      <span class="unit">件</span>
    </md-input-container>

    <div class="half-style center">
      <h4>臨時的な報酬の代表例として下記のものを記載しておきます。</h4>
    </div>

    <div class="half-style left">
      <h3>５．各種届出書提出</h3>
    </div>

    <div class="half-style center">
      <!-- TODO 定数化 -->
      <div class="small-text">1通　　＠5,000円</div>
    </div>

    <br>

    <div class="half-style left">
      <h3>６．消費税中間申告書作成・提出</h3>
    </div>

    <div class="half-style center">
      <!-- TODO 定数化 -->
      <div class="small-text">＠5,000円</div>
    </div>

    <br>

    <div id="shiharai-sogaku">
      <div class="mid-text">年間支払総額</div>
      {{nenkanShiharaiSogaku.toLocaleString()}}円
      <span class="mid-text">(税抜)</span>
    </div>

    <md-button class="mitsumori-button md-raised md-primary" v-show="!isShowing" @click="toggleShow">
      御見積書表示
    </md-button>
    <md-button class="mitsumori-button md-raised md-primary" v-show="isShowing" @click="toggleShow">
      御見積書非表示
    </md-button>

    <div v-show="isShowing" id="mitsumori-syo-wrapper">
      <div id="mitsumori-syo">
        <div id="mitsumori-title">御見積書</div>
        <div id="mitsumori-client-wrapper">
          <div id="mitsumori-client">
            <span id="mitsumori-name">{{gyosyuKbn}}</span>
            <span id="mitsumori-sama">様</span>
          </div>
        </div>
        <div id="mitsumori-contact-wrapper">
          <div id="mitsumori-contact">
            〒355-0027<br>
            埼玉県東松山市美土里町6-67<br>
            服部税理士事務所<br>
            TEL 0493-81-6162<br>
            FAX 0493-81-6163<br>
          </div>
        </div>
        <div id="mitsumori-cost-wrapeer">
          下記の通りお見積もり申し上げます。
          <table id="mitsumori-cost-table" cellspacing="0">
            <tr>
              <td id="mitsumori-cost-title">お見積もり金額 <br>（消費税込）</td>
              <td id="mitsumori-cost">{{mitsumoriGokei.toLocaleString()}} 円</td>
            </tr>
          </table>
        </div>
        <div class="left">見積明細</div>
        <table id="mitsumori-table" cellspacing="0">
          <tr>
            <th>内容</th>
            <th>数量</th>
            <th>単位</th>
            <th>単価</th>
            <th>金額</th>
          </tr>
          <tr v-if="homonKaisu !== '年一'">
            <td>月次顧問報酬</td>
            <td class="right">12</td>
            <td>ヶ月</td>
            <td class="right">{{getsugakuKomonryo.toLocaleString()}}</td>
            <td class="right">{{(getsugakuKomonryo * 12).toLocaleString()}}</td>
          </tr>
          <tr>
            <td>決算報酬</td>
            <td class="right">{{homonKaisu === '年一' ? 1 : kessanKaisu}}</td>
            <td>ヶ月</td>
            <td class="right">{{homonKaisu === '年一' ? kessanHosyuNen.toLocaleString() :
              getsugakuKomonryo.toLocaleString()}}
            </td>
            <td class="right">{{homonKaisu === '年一' ? kessanHosyuNen.toLocaleString() :
              (getsugakuKomonryo * kessanKaisu).toLocaleString()}}
            </td>
          </tr>
          <tr>
            <td>{{kaikeiSoftKbn === '記帳代行' ? '記帳代行手数料' : homonKaisu === '年一' ? '記帳代行手数料' : '戦略経営者システムサポート'}}</td>
            <td class="right">12</td>
            <td>ヶ月</td>
            <td class="right">{{getsugakuShiharaiKingaku.toLocaleString()}}</td>
            <td class="right">{{(getsugakuShiharaiKingaku * 12).toLocaleString()}}</td>
          </tr>
          <tr v-if="nenkanGokei !== 0">
            <td>{{kyuyoKeisanDaiko === '有' ? '給与計算手数料' : '年末調整手数料'}}</td>
            <td class="right">{{kyuyoKeisanDaiko === '有' ? 12 : zyugyoinSu}}</td>
            <td>{{kyuyoKeisanDaiko === '有' ? 'ヶ月' : '人'}}</td>
            <td class="right">{{kyuyoKeisanDaiko === '有' ? kyuyoKeisanGetsugaku.toLocaleString() :
              nenkanGokei.toLocaleString()}}
            </td>
            <td class="right">{{kyuyoKeisanDaiko === '有' ? (kyuyoKeisanGetsugaku * 12).toLocaleString() :
              nenkanGokei.toLocaleString()}}
            </td>
          </tr>
          <tr v-if="nenkanGokei !== 0 && kyuyoKeisanDaiko === '有'">
            <td>年末調整手数料</td>
            <td class="right">1</td>
            <td>回</td>
            <td class="right">{{nenmatsuCyoseiHosyu.toLocaleString()}}</td>
            <td class="right">{{nenmatsuCyoseiHosyu.toLocaleString()}}</td>
          </tr>
          <tr v-if="zeimuDairiTesuryo !== 0">
            <td>償却資産税 申告報酬</td>
            <td class="right">1</td>
            <td>回</td>
            <td class="right">{{zeimuDairiTesuryo.toLocaleString()}}</td>
            <td class="right">{{zeimuDairiTesuryo.toLocaleString()}}</td>
          </tr>
          <tr v-if="homonKaisu !== '年一'">
            <td>電子帳簿作成代、TISCﾊﾞｯｸｱｯﾌﾟ,ﾘﾓｰﾄﾃﾞｨｽﾌﾟﾚｲ</td>
            <td class="right">1</td>
            <td>式</td>
            <td class="right">10,000</td>
            <td class="right">10,000</td>
          </tr>
          <tr v-for="_ in Array(6)">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td class="mitsumori-kei" colspan="4">小計</td>
            <td class="right">{{mitsumoriSyokei.toLocaleString()}}</td>
          </tr>
          <tr>
            <td class="mitsumori-kei" colspan="4">消費税</td>
            <td class="right">{{mitsumoriZei.toLocaleString()}}</td>
          </tr>
          <tr>
            <td class="mitsumori-kei" colspan="4">合計</td>
            <td class="right">{{mitsumoriGokei.toLocaleString()}}</td>
          </tr>
        </table>
        <md-button id="mitsumori-print-button" class="mitsumori-button md-raised" v-show="isShowing" @click="print">
          印刷
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
  function asNum(str) {
    return Number(str.replace(/,/g, ''))
  }

  export default {
    name : 'Mitsumori',
    components : {},
    data() {
      return {
        soshikiKbn : '法人',
        gyosyuKbn : '卸売業',
        syohizeiKbn : '免税事業者',
        homonKaisu : '月次',
        zenUri : '',
        zenZenUri : '',
        zenHosyu : '',
        zenZenHosyu : '',
        kaikeiSoftKbn : '記帳代行',
        shiwakeSu : '',
        tyoboKbn : '',
        kyuyoKeisanDaiko : '無',
        zyugyoinSu : '',
        shityosonSu : '',
        zeimusyoSu : '',
        fudosanSu : '',
        hosyuSu : '',
        sonotaSu : '',
        teisyutsuShityoson : '',
        idoShisan : '',

        isShowing : false
      }
    },
    computed : {
      mitsumoriExtendLines : function () {
        var count = 6
        count += this.homonKaisu !== '年一' ? 0 : 1
        count += this.nenkanGokei !== 0 ? 0 : 1
        count += this.nenkanGokei !== 0 && this.kyuyoKeisanDaiko === '有' ? 0 : 1
        count += this.zeimuDairiTesuryo !== 0 ? 0 : 1
        count += this.homonKaisu !== '年一' ? 0 : 1
        return count
      },
      // 見積書小計
      mitsumoriSyokei : function () {
        var syokei = 0
        syokei += this.homonKaisu !== '年一' ? this.getsugakuKomonryo * 12 : 0
        syokei += this.homonKaisu === '年一' ? this.kessanHosyuNen : this.getsugakuKomonryo * this.kessanKaisu
        syokei += this.getsugakuShiharaiKingaku * 12
        syokei += this.nenkanGokei !== 0 ? this.kyuyoKeisanDaiko === '有' ? this.kyuyoKeisanGetsugaku * 12 : this.nenkanGokei : 0
        syokei += this.nenkanGokei !== 0 && this.kyuyoKeisanDaiko === '有' ? this.nenmatsuCyoseiHosyu : 0
        syokei += this.zeimuDairiTesuryo !== 0 ? this.zeimuDairiTesuryo : 0
        syokei += this.homonKaisu !== '年一' ? 10000 : 0
        return syokei
      },
      // 見積書小計
      mitsumoriZei : function () {
        return this.mitsumoriSyokei * 0.08
      },
      // 見積書小計
      mitsumoriGokei : function () {
        return this.mitsumoriSyokei + this.mitsumoriZei
      },
      // エクセル関数に該当
      // I72
      nenmatsuGokei : function () {
        return Number(this.shityosonSu) + Number(this.zeimusyoSu) + Number(this.fudosanSu) + Number(this.hosyuSu) + Number(this.sonotaSu)
      },
      // I170
      heikinUriage : function () {
        if (asNum(this.zenZenUri) <= 0) {
          return asNum(this.zenUri)
        } else {
          return Math.round((asNum(this.zenUri) + asNum(this.zenZenUri)) / 2)
        }
      },
      // I171
      heikinKyuyo : function () {
        if (asNum(this.zenZenHosyu) <= 0) {
          return asNum(this.zenHosyu)
        } else {
          return Math.round((asNum(this.zenHosyu) + asNum(this.zenZenHosyu)) / 2)
        }
      },
      // M172
      gyosyuBairitsu : function () {
        return ExcelUtils.generateKeyValues(MITSUMORI_CONSTANT['業種別加算率'])[this.gyosyuKbn].val2
      },
      // I165
      getsuziKomonHosyu : function () {
        return getsuziKomonHosyu(this.heikinUriage, this.heikinKyuyo, this.gyosyuBairitsu)
      },
      // P165
      getsuziKomonHosyuNen : function () {
        return getsuziKomonHosyuNen(this.soshikiKbn, this.getsuziKomonHosyu)
      },
      // I166
      saiteiHosyu : function () {
        return saiteiHosyu(this.soshikiKbn, this.getsuziKomonHosyu)
      },
      // Q171
      uriagedakaWaribiki : function () {
        return uriagedakaWaribiki(this.heikinUriage)
      },
      // I35
      getsugakuKomonryo : function () {
        return getsugakuKomonryo(this.homonKaisu, this.saiteiHosyu, this.uriagedakaWaribiki)
      },
      // I167
      kessanHosyu : function () {
        return kessanHosyu(this.soshikiKbn, this.getsugakuKomonryo)
      },
      // P167
      kessanHosyuNen : function () {
        return kessanHosyuNen(this.soshikiKbn, this.getsuziKomonHosyuNen)
      },
      // I168
      syohizeiHosyu : function () {
        return syohizeiHosyu(this.syohizeiKbn, this.getsugakuKomonryo)
      },
      // P168
      syohizeiHosyuNen : function () {
        return syohizeiHosyuNen(this.syohizeiKbn, this.getsuziKomonHosyuNen)
      },
      // I37
      kessanRyo : function () {
        return kessanRyo(this.homonKaisu, this.kessanHosyu, this.kessanHosyuNen, this.syohizeiHosyu, this.syohizeiHosyuNen)
      },

      // Q214
      uriagedakaKijun : function () {
        return uriagedakaKijun(this.soshikiKbn, this.heikinUriage)
      },
      // I214
      kaikeiSystemSupportRyo : function () {
        return kaikeiSystemSupportRyo(this.kaikeiSoftKbn, this.homonKaisu, this.uriagedakaKijun, asNum(this.zyugyoinSu))
      },
      // I216
      kityodaikoTesuryo : function () {
        return kityodaikoTesuryo(asNum(this.shiwakeSu), this.kaikeiSystemSupportRyo, this.uriagedakaWaribiki)
      },
      // I220
      kasanritsu : function () {
        return kasanritsu(this.tyoboKbn)
      },
      // I218
      tyoboSeiriKasangaku : function () {
        return tyoboSeiriKasangaku(this.kityodaikoTesuryo, this.kasanritsu)
      },
      // I222
      mototyo : function () {
        return mototyo(this.kaikeiSoftKbn, asNum(this.shiwakeSu))
      },
      // I50
      getsugakuShiharaiKingaku : function () {
        return getsugakuShiharaiKingaku(this.homonKaisu, this.kaikeiSystemSupportRyo, this.kityodaikoTesuryo, this.tyoboSeiriKasangaku)
      },

      // I76
      kyuyoKeisanGetsugaku : function () {
        return kyuyoKeisanGetsugaku(this.kyuyoKeisanDaiko, asNum(this.zyugyoinSu))
      },
      // I78
      nenmatsuCyoseiHosyu : function () {
        return nenmatsuCyoseiHosyu(asNum(this.zyugyoinSu), this.nenmatsuGokei)
      },
      // I80
      nenkanGokei : function () {
        return nenkanGokei(this.kyuyoKeisanGetsugaku, this.nenmatsuCyoseiHosyu)
      },

      // I91
      zeimuDairiTesuryo : function () {
        return zeimuDairiTesuryo(Number(this.teisyutsuShityoson), Number(this.idoShisan))
      },

      // V93
      nenkanShiharaiSogaku : function () {
        return nenkanShiharaiSogaku(this.getsugakuKomonryo, this.kessanRyo, this.getsugakuShiharaiKingaku, this.nenkanGokei, this.zeimuDairiTesuryo, this.mototyo)
      },
      // W167
      kessanKaisu : function () {
        return kessanKaisu(this.soshikiKbn, this.syohizeiKbn)
      }
    },
    methods : {
      validateNumber : function (event) {
        if (event.inputType === 'insertCompositionText') {
          return
        }

        // 全角 → 半角、数値以外を除外
        event.target.value = event.target.value.replace(/[０-９]/g, function (s) {return String.fromCharCode(s.charCodeAt(0) - 65248)}).replace(/[^0-9]/g, '')
      },
      manageComma : function (key, hasFocus) {
        // コンマ追加、削除
        if (hasFocus) {
          // this[key] = this[key].replace(/,/g, '')
        } else {
          this[key] = this[key] ? Number(this[key].replace(/[^0-9]/g, '').replace(/,/g, '')).toLocaleString() : this[key]
        }
      },
      toggleShow : function () {
        this.isShowing = !this.isShowing

        if (this.isShowing) {
          // 見積書までスクロール
          setTimeout(function () {
            var y = document.getElementById('mitsumori-syo-wrapper')
              .getBoundingClientRect().top + window.scrollY - 32
            window.scroll({top : y, behavior : 'smooth'})
          }, 100)
        }
      },
      print : function () {
        var el = '#mitsumori-syo-wrapper'
        var iframe = document.createElement('IFRAME')
        var doc = null
        $(iframe).attr('style', 'position:absolute;width:0px;height:0px;left:-500px;top:-500px;')
        // $(iframe).attr('style', 'position:absolute;width:1000px;height:500px;left:0px;top:0px;')
        document.body.appendChild(iframe)
        doc = iframe.contentWindow.document
        doc.write('<div class="' + $(el).attr('class') + '">' + $(el).html() + '</div>')
        $('body', doc)[0].style.webkitPrintColorAdjust = 'exact'
        $('body', doc)[0].style.colorAdjust = 'exact'

        $('#mitsumori-print-button', doc).remove()

        // Styleをコピー
        var parentStyleSheets = document.styleSheets
        var cssString = ''
        for (var i = 0; i < parentStyleSheets.length; i++) {
          if (parentStyleSheets[i].cssRules) {
            var cssRules = parentStyleSheets[i].cssRules
            for (var j = 0; j < cssRules.length; j++)
              cssString += cssRules[j].cssText
          } else {
            cssString += parentStyleSheets[i].cssText
          }
        }
        var style = doc.createElement('style')
        style.type = 'text/css'
        style.innerHTML = cssString
        doc.getElementsByTagName('head')[0].appendChild(style)

        doc.close()
        iframe.contentWindow.focus()
        setTimeout(function () {
          iframe.contentWindow.print()
          setTimeout(function () {
            document.body.removeChild(iframe)
          }, 100)
        }, 100)
      }
    }
  }
</script>


<style scoped>
  input[type=text] {
    font-size : 16px;
  }

  #mitsumori-wrapper {
    color            : #0B0B61;
    display          : flex;
    flex-flow        : column;
    align-items      : center;
    justify-content  : center;
    width            : 60%;
    margin           : auto;
    background-color : white;
    border-radius    : 4px;
    box-shadow       : 1px 1px 4px gray;
  }

  @media screen and (max-width : 1024px) {
    #mitsumori-wrapper {
      width : 90%;
    }
  }

  .title {
    margin        : 32px 0;
    padding       : 8px 48px;
    border-bottom : 1px #D4E6FF solid;
  }

  .label-style {
    font-size : 12px;
    color     : rgba(0, 0, 0, 0.54);
  }

  .half-style {
    width     : 50%;
    max-width : 50%;
  }

  .sub-content {
    margin-left : 4%;
    width       : 46%;
  }

  @media screen and (max-width : 1024px) {
    .title {
      padding : 8px 16px;
    }

    .half-style {
      width     : 80%;
      max-width : 80%;
    }

    .sub-content {
      margin-left : 8%;
      width       : 72%;
    }
  }

  .unit {
    padding : 6px;
  }

  .right {
    text-align : right !important;
  }

  .left {
    text-align : left !important;
  }

  .center {
    text-align : center !important;
  }

  #shiharai-sogaku {
    width            : 50%;
    font-size        : 36px;
    line-height      : 36px;
    padding          : 12px 24px 8px 24px;
    border-top       : 1px #0B0B61 solid;
    border-bottom    : 1px #0B0B61 solid;
    background-color : #EAF2FF;
  }

  @media screen and (max-width : 1024px) {
    #shiharai-sogaku {
      width : 90%;
    }
  }

  .mid-text {
    font-size : 24px;
  }

  .small-text {
    font-size : 16px;
  }

  .mitsumori-button {
    margin    : 24px 32px;
    font-size : 16px;
  }

  #mitsumori-syo-wrapper {
    margin-top : 32px;
    width      : 90%;
    overflow-x : auto;
  }

  #mitsumori-syo {
    min-width : 600px;
  }

  #mitsumori-title {
    width          : 100%;
    font-size      : 32px;
    line-height    : 32px;
    letter-spacing : 2em;
    padding-left   : 2em;
    margin-bottom  : 32px;
  }

  #mitsumori-client-wrapper {
    width      : 100%;
    text-align : left;
  }

  #mitsumori-client {
    width         : fit-content;
    border-bottom : 1px #0B0B61 solid;
  }

  #mitsumori-name {
    display    : inline-block;
    text-align : center;
    width      : 160px;
  }

  #mitsumori-sama {
    display    : inline-block;
    text-align : center;
    width      : 32px;
  }

  #mitsumori-contact-wrapper {
    width : 100%;
  }

  #mitsumori-contact {
    width      : fit-content;
    text-align : left;
    float      : right;
  }

  #mitsumori-cost-wrapeer {
    margin     : 48px 0 32px 0;
    width      : 100%;
    text-align : left;
  }

  #mitsumori-cost-table {
    width  : fit-content;
    border : 2px #0B0B61 solid;
  }

  #mitsumori-cost-title {
    padding      : 0 16px;
    font-weight  : bold;
    border-right : 2px #0B0B61 solid;
  }

  #mitsumori-cost {
    padding-left : 32px;
  }

  #mitsumori-table {
    width         : 100%;
    border        : 2px #0B0B61 solid;
    margin-bottom : 32px;
  }

  #mitsumori-table th {
    border              : 1px solid #0B0B61;
    border-bottom-width : 2px;
  }

  #mitsumori-table tr:nth-child(2n+1) {
    background : #F2FCFF;
  }

  #mitsumori-table tr:nth-child(1) {
    background : #EAF2FF;
  }

  #mitsumori-table tr:nth-last-child(1) {
    background : #EAF2FF;
  }

  #mitsumori-table td {
    border     : 1px #0B0B61 solid;
    padding    : 4px;
    text-align : left;
    height     : 30px;
  }

  .mitsumori-kei {
    font-weight   : bold;
    text-align    : right !important;
    padding-right : 32px !important;
  }
</style>

<style>
  .md-select-content {
    width : 30% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Mitsumori.vue